export enum PersonTypes {
  'Администратор' = 1,
  'Координатор',
  'Доброволец',
  'Подопечный',
}
